import { createNewTracker } from '@gartner-digital-markets/treebeard'

import getConfig from 'config/public'

let tracker

export const getTracker = () => {
  if (!tracker) {
    tracker = createNewTracker({
      appId: 'bx-getapp-www',
      collectorEndpoint: getConfig().snowPlow.collectorUrl,
      environment: getConfig().snowPlow.env,
    })
  }

  return tracker
}
